export default "__VITE_ASSET__CHRJKGZn__"